import { useTranslations } from 'next-intl';
import DeleteOutlineIcon from '@/components/ui/icons/delete-outline-icon';
import ImportIcon from '@/components/ui/icons/import-left';
import { LocationIcon } from '@/components/ui/icons';
import { deleteUserAddress } from '@/services/user/addresses';
import { toast } from '@/utils/toast';
import DeleteModal from '../modals/delete-modal';
import React, { useState } from 'react';
import { getCookie } from 'cookies-next';
import { SHIPPING_INFO_MODALS_NAMES } from '@/constants';

const HomeDeliveryAddressCard = ({
  setSelectedOption,
  address,
  selectedOption,
  setModalStep,
  setSelectedAddress,
  mutate,
  setAddressType,
}) => {
  const mage = getCookie('mage');
  const t = useTranslations('modals');

  const [isDeleting, setIsDeleting] = useState(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);

  // const isDefault = address.default_shipping && address.default_billing;

  const toggleModal = () => setIsModalDeleteOpen(!isModalDeleteOpen);
  const handleDelete = async (addressId) => {
    setIsDeleting(true);
    deleteUserAddress({ id: addressId, mage })
      .then((res) => {
        if (res?.data?.data) {
          toast.success(res?.data?.message);
          if (mutate) mutate();
          setIsModalDeleteOpen(false);
        } else {
          toast.error(res?.data?.message || res?.error.error?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.message);
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  return (
    <>
      <div
        className={`hover:border-primary flex h-[5.313rem] cursor-pointer items-center justify-between rounded-[10px] border px-[19px] transition-all duration-150 ${address?.id === selectedOption?.id ? 'border-primary' : 'border-[#D9D9D9]'}`}
      >
        <div
          onClick={() => setSelectedOption(address)}
          className='flex h-full w-full items-center gap-[16px]'
        >
          <div className='flex h-12 w-12 items-center justify-center rounded-full bg-[#F2F3F5]'>
            <LocationIcon className='h-[27px] w-[27px]' />
          </div>

          <div>
            <h3 className='mb-[7px] text-[16px] font-bold max-sm:text-sm'>
              {t('Home')}
            </h3>
            <p className='line-clamp-1 text-sm max-sm:text-xs'>{`${address?.street?.[0]}, ${address?.region?.region}, ${address?.country_id}`}</p>
          </div>
        </div>

        <div className='flex items-center gap-[22px] max-sm:gap-2'>
          <button
            onClick={() => {
              setModalStep(SHIPPING_INFO_MODALS_NAMES.ADD_EDIT_ADDRESS);
              setSelectedAddress(address);
              setAddressType(
                address?.custom_attributes?.find(
                  (e) => e?.attribute_code === 'address_type'
                )?.value
              );
            }}
          >
            <ImportIcon />
          </button>
          {/* {!isDefault && ( */}
          <button type='button' onClick={() => setIsModalDeleteOpen(true)}>
            <DeleteOutlineIcon />
          </button>
          {/* )} */}
        </div>
      </div>

      {isModalDeleteOpen && (
        <DeleteModal
          title={t('delete_address_key')}
          message={t('delete_message_msg_key')}
          onDelete={() => handleDelete(address?.id)}
          isDeleting={isDeleting}
          isOpen={isModalDeleteOpen}
          onClose={() => toggleModal()}
        />
      )}
    </>
  );
};

export default HomeDeliveryAddressCard;
